<template>
  <div class="share-com">
    <van-popup v-model="show"
               :close-on-click-overlay="true"
               :show-confirm-button="false"
               round
               style="{height: '100%'}">
      <div class="share-box">
        <div class="index-banner">
          <div class="banner">
            <van-swipe indicator-color="white"
                       :width="345">
              <van-swipe-item v-for="(item,index) in bannerList"
                              :key="index">
                <img :src="item.img" />
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
        <div class="btn">
          <p>长按图片保存</p>
        </div>
        <i class="close"
           @click="show=false"></i>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "",
  data () {
    return {
      qrimg: "",
      show: false,
      bannerList: []
    };
  },
  methods: {
    getUrl () {
      if (this.$route.query.type == 'CheckIn') {
        this.$http
          .post(`/api/app/checkin/sharePic`, {
            id: this.$route.query.paper_id,
            url: document.URL + "&share=1"
          })
          .then(res => {
            this.bannerList.push({ img: res.base64 });
          });
      } else {
        let url = window.location.href;
        let type = 1;//课程
        if (url.indexOf('exerciseDetail') > 0) {//章节练习
          type = 2;
        } else if (url.indexOf('examDetail') > 0) {//模拟考试
          type = 3;
        }
        this.$http.get(`/api/app/shareTemplate/list`, { type: type }).then(res => {
          res.forEach(item => {
            this.$http
              .post(`/api/app/shareTemplate/sharePic`, {
                template_id: item.id,
                url: document.URL + "&share=1",
                course_id: this.$route.query.id,
                type: type
              })
              .then(res => {
                this.bannerList.push({ img: res.base64 });
              });
          });
        });
      }
    },
    showModel () {
      this.show = true;
    }
  },
  created () {
    this.getUrl();
  }
};
</script>

<style lang="scss" scoped>
.share-com /deep/ .van-overlay {
  background: #fff;
}
.share-box {
  width: 100vw;
  height: 100vh;
  background: #fbfbfb;
  box-sizing: border-box;
  padding-bottom: 100px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}
.index-banner {
  margin: 0 auto;
  padding: 30px;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  .van-swipe {
    height: 100%;
  }
  .banner {
    position: relative;
    background-position: center center;
    background-size: cover;
    img {
      width: 100%;
      // height: 990px;
      border-radius: 20px;
    }
  }
}
.btn {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100px;
  background: #fff;
  box-shadow: 0px -6px 30px 0px rgba(0, 0, 0, 0.07);
  border-radius: 20px 20px 0px 0px;
  p {
    text-align: center;
    font-size: 32px;
    font-family: PingFangSC;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
    line-height: 100px;
  }
}
.close {
  width: 50px;
  height: 50px;
  background: url("../assets/images/close.png") no-repeat center center;
  background-size: 30px 30px;
  position: absolute;
  right: 30px;
  top: 30px;
}
</style>
